<!--
  - Copyright (c) 2022 by Leyton Group - All Rights Reserved.
  - This source code, and resulting software, is the confidential and proprietary information
  - ("Proprietary Information") and is the intellectual property ("Intellectual Property")
  - of Leyton Group, Inc. ("The Company"). You shall not disclose such Proprietary Information
  - and shall use it only in accordance with the terms and conditions of any and all license
  - agreements you have entered into with The Company.
  -->

<template>
<div id="Security">
  <b-row align-v="stretch">
    <b-col cols="12" class="py-4">
      <h4 class="font-weight-bold fsize-4 text-primary px-4 mb-5">
        {{ $t("authentication") }}
      </h4>
      <div class="px-4">
        <b-form-group
            :label="$t('current_password')"
            label-for="current_password"
            label-class="font-weight-bold font-size-sm"
        >
          <b-form-input
              style="max-width: 200px"
              class="border-raduis-xl border-color-success"
              v-model="account.current_password"
              id="current_password"
              type="password"
          ></b-form-input>
        </b-form-group>
        <b-button pill variant="success" class="mt-2 px-5">{{
            $t("edit_password")
          }}</b-button>
      </div>
    </b-col>
  </b-row>
</div>
</template>

<script>
export default {
  name: "Security",
  data: function () {
    return {
      account: {
        current_password: '',
      }
    }
  }
}
</script>

<style scoped>

</style>